import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Box, Checkbox, Flex, Text } from 'core/components';

@observer
export default class CustomersProvidersExportOptions extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    filterValues: PropTypes.object
  };

  static defaultProps = {
    disabled: false,
    onChange: () => {},
    filterValues: {}
  };

  state = {
    includeProviders: false,
    excludeMutual: false,
    onlySH: false
  };

  componentDidMount() {
    const { filterValues } = this.props;
    this.setState({
      includeProviders: filterValues.includeProviders || false,
      excludeMutual: filterValues.excludeMutual || false,
      onlySH: filterValues.onlySH || false
    });
  }

  handleCheckboxChange = (fieldName) => () => {
    const { onChange } = this.props;
    const { [fieldName]: currentValue } = this.state;
    const newValue = !currentValue;

    this.setState((prevState) => {
      const newState = {
        ...prevState,
        [fieldName]: newValue
      };
      onChange(newState);

      return newState;
    });
  };

  render() {
    const { disabled, ...rest } = this.props;
    const { includeProviders, excludeMutual, onlySH } = this.state;

    return (
      <Box mt={-1} mb={2} {...rest}>
        <Flex flexDirection="column" gap={1}>
          <Flex cursor="pointer" gap={1} onClick={this.handleCheckboxChange('includeProviders')}>
            <Checkbox checked={includeProviders} disabled={disabled} />
            <Text>Include Providers</Text>
          </Flex>
          <Flex cursor="pointer" gap={1} onClick={this.handleCheckboxChange('excludeMutual')}>
            <Checkbox checked={excludeMutual} disabled={disabled} />
            <Text>Exclude Mutual Customers</Text>
          </Flex>
          <Flex cursor="pointer" gap={1} onClick={this.handleCheckboxChange('onlySH')}>
            <Checkbox checked={onlySH} disabled={disabled} />
            <Text>Only Single Homed Customers</Text>
          </Flex>
        </Flex>
      </Box>
    );
  }
}
